import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { nativeShell } from '../lib/native/bridge';
import { pathFromUrl } from '../lib/native/links';

/**
 * Open links the system sends to the running app — a shared note tapped in
 * Messages while markbird is already open. Nothing happens in a browser, which
 * has an address bar for this.
 */
export function useNativeLinks(): void {
  const navigate = useNavigate();
  useEffect(() => {
    const shell = nativeShell();
    if (!shell?.onOpenUrl) return;
    shell.onOpenUrl((url) => {
      const path = pathFromUrl(url);
      if (path) navigate(path);
    });
  }, [navigate]);
}
